import React, {ReactNode, useContext, useEffect} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {matchRoutes} from 'react-router-config';
import qs from 'qs';
import AppContext from './AppContext';
import {useAuthToken} from './AppHooks';
import {Loader} from '../index';
import {checkPermission} from './Utils';
import {initialUrl} from '../../shared/constants/AppConst';
import {setInitialPath} from '../../redux/actions';
import {AppState} from '../../redux/store';
import AppContextPropsType from '../../types/AppContextPropsType';
import {NavStyle, ThemeMode, ThemeStyle} from '../../shared/constants/AppEnums';

interface AuthRoutesProps {
  children: ReactNode;
}

const AuthRoutes: React.FC<AuthRoutesProps> = ({children}) => {
  const {pathname, search} = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    routes,
    changeNavStyle,
    updateThemeStyle,
    updateThemeMode,
    setRTL,
  } = useContext<AppContextPropsType>(AppContext);

  const [loading, user] = useAuthToken();
  const {initialPath} = useSelector<AppState, AppState['settings']>(
    ({settings}) => settings,
  );
  // let authUser = useAuthUser();
  let matchedRoutes = matchRoutes(routes, pathname);
  const currentRoute = matchedRoutes[0].route;
  let isPermitted = checkPermission(currentRoute.auth, user ? user.role : null);

  useEffect(() => {
    function setInitPath() {

      if (
        initialPath === '/' &&
        [
          '/signin',
          '/signup',
          '/verifyemail',
          '/reset-password',
          '/error-pages/error-404',
          '/forgot-password',
        ].indexOf(pathname) === -1
      ) {
        if (isPermitted) {
          dispatch(setInitialPath(pathname));
        } else {
          //has layers/param? if yes, get the lesson from space, check ispublic
          // if(lesson is publicly available){}
          dispatch(setInitialPath(undefined));
        }
      }
    }

    setInitPath();
  }, [dispatch, isPermitted, initialPath, pathname]);

  useEffect(() => {
    function handleQueryParams() {
      const query = qs.parse(search.split('?')[1]);

      if (query.layout) {
        changeNavStyle(query.layout as NavStyle);
      }
      if (query.mode) {
        updateThemeMode(query.mode as ThemeMode);
      }
      if (query.rtl) {
        setRTL(true);
      }
      if (query.style) {
        updateThemeStyle!(query.style as ThemeStyle);
      }
    }

    if (search) {
      handleQueryParams();
    }
  }, [changeNavStyle, updateThemeMode, setRTL, updateThemeStyle, search]);

  useEffect(() => {
    if (!loading) {
      if (!user && !isPermitted) {

        history.push('/signin'); // allowed route
      } else if(user && !user.emailVerified){

        history.push('/signin'); // allowed route

      } else if (user && !isPermitted) {

        history.push('/error-pages/error-404'); // Not found
      } else if (user && isPermitted) {

        if (
          pathname === '/' ||
          pathname === '/signin' ||
          pathname === '/signup'
        ) {

          history.push(initialUrl);
        } else {
          // note - this logic redirect to bad url so don't need of initial path
          if (
            initialPath &&
            initialUrl !== initialPath &&
            initialPath !== '/'
            // initialPath !== '/signin' ||
            // initialPath !== '/signup')
          ) {

            // history.push(initialPath);
          }
        }
      }
    }
  }, [user, loading, initialPath, isPermitted, pathname, history]);

  return loading ? <Loader /> : <>{children}</>;
};

export default AuthRoutes;
